'use strict';
define([
    'angular',
    'modules/project/settings/settings.controller',
], function (angular, SettingsCtrl) {
    var app = angular.module('app.project.settings', []);
    app.controller('SettingsCtrl', SettingsCtrl);
    return app;
});
